var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13C10.0899 13 13 10.0899 13 6.5Z",
    fill: "#4AAE41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8419 3.87206C10.7781 3.95417 10.7376 4.01118 10.692 4.06364C9.01108 5.98456 7.32621 7.90206 5.65218 9.82925C5.48511 10.0214 5.38533 9.99574 5.20573 9.85833C4.24384 9.12395 3.27454 8.40039 2.30182 7.68083C2.1513 7.56965 2.10055 7.49496 2.24082 7.33131C2.44665 7.09127 2.63424 6.83355 2.81327 6.57184C2.91704 6.42017 2.98946 6.41105 3.13941 6.52737C3.76204 7.0086 4.40178 7.46759 5.02384 7.94938C5.19775 8.08395 5.28726 8.08794 5.44064 7.91118C6.8045 6.33864 8.18547 4.77978 9.54704 3.20496C9.73463 2.98829 9.84126 2.97346 10.0345 3.1793C10.2347 3.39254 10.4724 3.57044 10.6948 3.76259C10.7387 3.80079 10.7883 3.83272 10.8419 3.87206Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.440dbd0e64e94779e1b7a28238d39691.svg";
export { ForwardRef as ReactComponent };